'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronleft from '@common/__generated__/icon/SvgChevronleft';
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { chunk } from 'es-toolkit';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useSelectedSnapIndex } from '@/hooks/useSelectedSnapIndex';
import { WeeklyBestPhotoReviewListItem } from './WeeklyBestPhotoReviewListItem';
import type { WeeklyBestPhotoReviewItem } from './WeeklyBestPhotoReviewSectionServer';
interface WeeklyBestPhotoReviewSectionProps {
  items: WeeklyBestPhotoReviewItem[];
  className?: string;
}
export const WeeklyBestPhotoReviewSection = t0 => {
  const $ = _c(57);
  const {
    items,
    className
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: false,
      align: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  const currentSlide = useSelectedSnapIndex(emblaApi);
  const CHUNK_SIZE = isDesktop ? 6 : 2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== CHUNK_SIZE || $[2] !== className || $[3] !== currentSlide || $[4] !== emblaApi || $[5] !== emblaRef || $[6] !== isDesktop || $[7] !== items) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const chunkedList = chunk(items, CHUNK_SIZE);
      const isNotRender = items.length < 1;
      if (isNotRender) {
        t9 = null;
        break bb0;
      }
      if ($[16] !== className) {
        t8 = cn("flex w-full justify-center bg-Y-25 pt-60", "mobile-tablet:pt-32", className);
        $[16] = className;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      let t10;
      let t11;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = cn("flex flex-col items-center gap-24 px-40 content-container", "mobile-tablet:gap-16 mobile-tablet:px-0");
        t10 = cn("grid w-full grid-cols-[1fr_auto_1fr] items-end", "mobile-tablet:flex mobile-tablet:items-center mobile-tablet:px-20");
        t11 = <div className="mobile-tablet:hidden" />;
        $[18] = t10;
        $[19] = t11;
        $[20] = t6;
      } else {
        t10 = $[18];
        t11 = $[19];
        t6 = $[20];
      }
      let t12;
      let t13;
      if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = <header className="flex items-center"><h2 className={cn("font-700 text-Gray-900 typo-h4", "mobile-tablet:typo-body1")}>주간 BEST 포토리뷰!</h2></header>;
        t13 = cn("flex flex-1 items-center justify-end gap-8", "mobile-tablet:hidden");
        $[21] = t12;
        $[22] = t13;
      } else {
        t12 = $[21];
        t13 = $[22];
      }
      const t14 = currentSlide + 1;
      let t15;
      if ($[23] !== t14) {
        t15 = <span className="font-700 text-Gray-600">{t14}</span>;
        $[23] = t14;
        $[24] = t15;
      } else {
        t15 = $[24];
      }
      let t16;
      if ($[25] !== emblaApi) {
        t16 = () => emblaApi?.scrollPrev();
        $[25] = emblaApi;
        $[26] = t16;
      } else {
        t16 = $[26];
      }
      let t17;
      if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <SvgChevronleft className="size-18 text-Gray-500" />;
        $[27] = t17;
      } else {
        t17 = $[27];
      }
      let t18;
      if ($[28] !== t16) {
        t18 = <Button theme="sub-line" className="size-24 rounded-xxsmall bg-Gray-white p-0" onClick={t16}>{t17}</Button>;
        $[28] = t16;
        $[29] = t18;
      } else {
        t18 = $[29];
      }
      let t19;
      if ($[30] !== emblaApi) {
        t19 = () => emblaApi?.scrollNext();
        $[30] = emblaApi;
        $[31] = t19;
      } else {
        t19 = $[31];
      }
      let t20;
      if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = <SvgChevronright className="size-18 text-Gray-500" />;
        $[32] = t20;
      } else {
        t20 = $[32];
      }
      let t21;
      if ($[33] !== t19) {
        t21 = <Button theme="sub-line" className="size-24 rounded-xxsmall bg-Gray-white p-0" onClick={t19}>{t20}</Button>;
        $[33] = t19;
        $[34] = t21;
      } else {
        t21 = $[34];
      }
      let t22;
      if ($[35] !== t18 || $[36] !== t21) {
        t22 = <div className="flex">{t18}{t21}</div>;
        $[35] = t18;
        $[36] = t21;
        $[37] = t22;
      } else {
        t22 = $[37];
      }
      const t23 = <div className={t13}><p className="font-500 text-Gray-550 typo-body4">{t15}{" "}/ {chunkedList.length}</p>{t22}</div>;
      if ($[38] !== t23) {
        t7 = <header className={t10}>{t11}{t12}{t23}</header>;
        $[38] = t23;
        $[39] = t7;
      } else {
        t7 = $[39];
      }
      if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = cn("w-full overflow-hidden pb-60", "mobile-tablet:px-20 mobile-tablet:pb-32");
        $[40] = t4;
      } else {
        t4 = $[40];
      }
      t5 = emblaRef;
      t2 = "flex";
      let t24;
      if ($[41] !== isDesktop) {
        t24 = chunkItems => <div key={chunkItems[0].reviewId} className={cn(isDesktop ? "min-w-0 flex-[0_0_100%]" : "mr-32 min-w-0 flex-[0_0_auto] last:mr-0")}><ul className={cn("flex flex-wrap gap-16", "mobile-tablet:flex-col mobile-tablet:gap-12")}>{chunkItems.map(_temp)}</ul></div>;
        $[41] = isDesktop;
        $[42] = t24;
      } else {
        t24 = $[42];
      }
      t3 = chunkedList.map(t24);
    }
    $[1] = CHUNK_SIZE;
    $[2] = className;
    $[3] = currentSlide;
    $[4] = emblaApi;
    $[5] = emblaRef;
    $[6] = isDesktop;
    $[7] = items;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[43] !== t2 || $[44] !== t3) {
    t10 = <div className={t2}>{t3}</div>;
    $[43] = t2;
    $[44] = t3;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  let t11;
  if ($[46] !== t10 || $[47] !== t4 || $[48] !== t5) {
    t11 = <div className={t4} ref={t5}>{t10}</div>;
    $[46] = t10;
    $[47] = t4;
    $[48] = t5;
    $[49] = t11;
  } else {
    t11 = $[49];
  }
  let t12;
  if ($[50] !== t11 || $[51] !== t6 || $[52] !== t7) {
    t12 = <div className={t6}>{t7}{t11}</div>;
    $[50] = t11;
    $[51] = t6;
    $[52] = t7;
    $[53] = t12;
  } else {
    t12 = $[53];
  }
  let t13;
  if ($[54] !== t12 || $[55] !== t8) {
    t13 = <section className={t8}>{t12}</section>;
    $[54] = t12;
    $[55] = t8;
    $[56] = t13;
  } else {
    t13 = $[56];
  }
  return t13;
};
function _temp(t0) {
  const {
    reviewId,
    contents,
    productName,
    rating,
    fileUrl
  } = t0;
  return <WeeklyBestPhotoReviewListItem key={reviewId} reviewId={reviewId} productThumbnailUrl={fileUrl} productName={productName} rating={rating} reviewContent={contents} />;
}